import requestFunctions from "../../functions/requestFunctions";


export const state = {
  SESSIONS_ITEM: {},
  SESSIONS_LIST: [],
  SESSIONS_TOTAL_ROWS: 0
}

export const getters = {
  GET_SESSIONS_ITEM: (state) => {
    return state.SESSIONS_ITEM;
  },
  GET_SESSIONS_LIST: (state) => {
    return state.SESSIONS_LIST;
  },
  GET_SESSIONS_TOTAL_ROWS: (state) => {
    return state.SESSIONS_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_SESSIONS_ITEM(state, item) {
    state.SESSIONS_ITEM = item;
  },
  UPDATE_SESSIONS_LIST(state, list) {
    state.SESSIONS_LIST = list.data;
    state.SESSIONS_TOTAL_ROWS = list.total;
    list = list.data;
  },
  CLEAR_SESSIONS_ITEM(){
    state.SESSIONS_ITEM.uuid   = null;
    state.SESSIONS_ITEM.ip     = null;
    state.SESSIONS_ITEM.token  = null;
    state.SESSIONS_ITEM.status = null;
    state.SESSIONS_ITEM.user   = null;
    state.SESSIONS_ITEM.created_at = null;
    state.SESSIONS_ITEM.updated_at = null;
    state.SESSIONS_ITEM.deleted_at = null;
  }
}

export const actions = {

  async FETCH_SESSIONS_ITEM({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/sessions/'+window.localStorage.getItem('API_KEY_ZABOTA');

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SESSIONS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_SESSIONS_LIST({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/sessions';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SESSIONS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_SESSIONS_CREATE({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/sessions';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_SESSIONS_UPDATE({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/sessions/'+window.localStorage.getItem('API_KEY_ZABOTA');

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_SESSIONS_DELETE({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/sessions/' + window.localStorage.getItem('API_KEY_ZABOTA');

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    window.localStorage.removeItem('API_KEY_ZABOTA');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('CLEAR_SESSIONS_ITEM', response.data);
      return response.data;
    }
  },
}
